import { render, staticRenderFns } from "./DatosPreguardados.vue?vue&type=template&id=072bce2c&scoped=true&"
import script from "./DatosPreguardados.vue?vue&type=script&lang=js&"
export * from "./DatosPreguardados.vue?vue&type=script&lang=js&"
import style0 from "./DatosPreguardados.vue?vue&type=style&index=0&id=072bce2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072bce2c",
  null
  
)

export default component.exports